export const roles = [
  { value: 'SuperAdmin', key: 1 },
  { value: 'AdminLv1', key: 2 },
  { value: 'AdminLv2', key: 3 },
  { value: 'User', key: 4 },
  { value: 'Demo', key: 5 },
];
